import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      '& .MuiOutlinedInput-input': {
        // padding: '10px !important',
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main
      }
    },
    '& label': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  chip: {
    borderRadius: '4px',
    textTransform: 'uppercase'
  },
  popper: {},
  listbox: {
    maxHeight: '200px',
    overflowY: 'auto',
    ...theme.scrollbarStyles,
    '& .MuiAutocomplete-option': {
      padding: '0px 8px',
      margin: '0',
    }
  }
}))
